//
// This file provides helper functions to local/save/clean authedUser object from local storage.
// Note that local storage has nothing to do with UI component state or context manipulations.
//

const AUTHED_USER_KEY = "authedUser";

// Save the authenticated user info (entire login response object) to local storage
export const saveAuthedUser = (authedUser) => {
  localStorage.setItem(AUTHED_USER_KEY, JSON.stringify(authedUser));
};

// Load the authenticated user info from local storage
export const loadAuthedUser = () => {
  const authedUserJson = localStorage.getItem(AUTHED_USER_KEY);
  return authedUserJson ? JSON.parse(authedUserJson) : null;
};

// Clear the authenticated user info (logout) from local storage
export const cleanAuthedUser = () => {
  localStorage.removeItem(AUTHED_USER_KEY);
};

